import { RoomV2Entity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomUpdate1Cmd {
  private static validation = JsonSchemaValidator.compile(
    RoomUpdate1Cmd.validationSchema(),
    RoomV2Entity
  );

  constructor(readonly value: RoomUpdate1CmdRaw) {
    JsonSchemaValidator.assert(RoomUpdate1Cmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["room"],
      properties: {
        room: {
          instanceof: RoomV2Entity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomUpdate1CmdRaw {
  room: RoomV2Entity;
}
